import Vue from "vue";
import VueRouter from "vue-router";
import Orders from "@/views/Orders.vue";
import Validations from "@/views/Validations.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/orders",
  },
  {
    path: "/orders",
    name: "Orders",
    component: Orders,
  },
  {
    path: "/orders/create",
    name: "Orders Create",
    component: Orders,
  },
  {
    path: "/orders/:_id",
    name: "Orders Details",
    component: Orders,
  },
  {
    path: "/validations",
    name: "Validations",
    component: Validations,
  },
  {
    path: "/validations/:_id",
    name: "Validation Details",
    component: Validations,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
